/**
 * T8007 · `refetchOnMount` function form — `lastReconnectAt` gate.
 *
 * SPEC ANCHOR: `specs/009-data-fetching-audit/05-new-infra-sdk-changes.html`
 * §L1296 — fixes verified TanStack bug #7 (refetchOnMount: 'always'
 * short-circuits the staleTime gate, causing 50-card cold-mount = 50 GETs
 * even with fresh cache).
 *
 * The function form returns `true` ONLY when row data is OLDER than the
 * most-recent NATS reconnect — combined with T8004 fan-out, this covers:
 *   (a) mounted-during-outage via fan-out;
 *   (b) unmounted-during-outage via this remount predicate.
 *
 * The function reads `lastReconnectAt` via `connectivityStore.getState()`
 * (NOT a hook) so it works outside React — TanStack calls
 * `refetchOnMount(query)` from `query-core` which is not in a render
 * cycle.
 */

import type { Query } from '@tanstack/react-query';
import { connectivityStore } from '../core/connectivity-store.js';

/**
 * The canonical realtime `refetchOnMount` function. Returns `true` when
 * `query.state.dataUpdatedAt < lastReconnectAt`.
 */
export function realtimeRefetchOnMount(query: Query): boolean {
  const lastReconnectAt = connectivityStore.getState().lastReconnectAt;
  return query.state.dataUpdatedAt < lastReconnectAt;
}
